import { TechnologyGateway } from '@price-card/gateways/technology.gateway';
import { environment } from '../../../../../environments/environment';
import { Technology } from '@price-card/models/technology.model';
import { formatGetHeaders } from '@configurations/api-configuration';

export class ApiTechnologyGateway implements TechnologyGateway {
  private readonly technologyApi = `${environment.backend_url}/api/v1/price-card/subtype`;

  async retrieveAll(): Promise<Technology[]> {
    try {
      const response = await fetch(`${this.technologyApi}`, await formatGetHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving technologies: ' + error);
    }
  }
}
